var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71429 4.64355C2.7292 4.64355 1.78445 5.03488 1.08789 5.73144C0.391325 6.42801 0 7.37275 0 8.35784V41.7864C0 43.264 0.586988 44.6812 1.63183 45.726C2.67668 46.7709 4.09379 47.3578 5.57143 47.3578H45.5C47.2239 47.3578 48.8772 46.673 50.0962 45.454C51.3152 44.235 52 42.5817 52 40.8578V16.715C52 15.6893 51.1685 14.8578 50.1429 14.8578H46.5011L46.5011 38.8472C46.5011 40.1292 45.4618 41.1686 44.1797 41.1686C42.8976 41.1686 41.8583 40.1292 41.8583 38.8472V13.9036C41.8583 13.884 41.8585 13.8645 41.859 13.845V8.35784C41.859 7.37275 41.4677 6.42801 40.7711 5.73144C40.0745 5.03488 39.1298 4.64355 38.1447 4.64355H3.71429ZM10.346 14.9922C10.346 13.9665 11.1775 13.135 12.2031 13.135H28.9174C29.9431 13.135 30.7746 13.9665 30.7746 14.9922V24.2779C30.7746 25.3036 29.9431 26.135 28.9174 26.135H12.2031C11.1775 26.135 10.346 25.3036 10.346 24.2779V14.9922ZM9.88058 36.2147C9.88058 34.9326 10.9199 33.8933 12.202 33.8933H28.9163C30.1984 33.8933 31.2377 34.9326 31.2377 36.2147C31.2377 37.4968 30.1984 38.5361 28.9163 38.5361H12.202C10.9199 38.5361 9.88058 37.4968 9.88058 36.2147Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNews);
export default __webpack_public_path__ + "static/media/news.498ca9fbcde8d212ad9b6b2e3dc778cf.svg";
export { ForwardRef as ReactComponent };